import { AudioPlayer } from 'src/components/audioPlayer'
import { useDecision } from '@optimizely/react-sdk'
import { useUser } from 'src/hook/useUser'
import { CustomAudio } from './audioPreviewContent.styles'
import { AudioPreviewContentProps } from './audioPreviewContent.types'

const AudioPreviewContent = ({ src, isPublication, componentName }: AudioPreviewContentProps) => {
  const { theme } = useUser()
  const [{ enabled: isEnabledAudioPostConsume }] = useDecision(
    'com_eng_web_enable_audio_post_consume'
  )

  if (isEnabledAudioPostConsume) {
    return <AudioPlayer src={src as string} componentName={componentName} />
  }

  return (
    <CustomAudio controls preload="metadata" theme={theme} className={isPublication ? '_mb-4' : ''}>
      <source src={src} type="audio/mp4" />
    </CustomAudio>
  )
}

export default AudioPreviewContent
